import { libraries } from "./registry";

export const getComponent = (type, variant = "variant1") => {
  const group = libraries[type];
  if (!group) return null;
  return group[variant]?.Component || group.variant1?.Component || null;
};

export const getComponentMetadata = (type, variant = "variant1") => {
  return libraries[type]?.[variant]?.metadata || {};
};

export const getEditableDefaults = (type, variant = "variant1") => {
  return libraries[type]?.[variant]?.metadata || {};
};

export const getTokenDefaults = () => {
  const defaults = {};
  Object.keys(libraries).forEach((type) => {
    Object.keys(libraries[type]).forEach((variant) => {
      const tokens = libraries[type][variant]?.metadata?.tokens || {};
      Object.keys(tokens).forEach((token) => {
        defaults[token] = tokens[token].default;
      });
    });
  });
  return defaults;
};

export const componentRegistry = libraries;
